import React, { useEffect, useState } from "react";
import Corner from "./../corner1";
import { SiInstructure } from "react-icons/si";
import { IoIosConstruct } from "react-icons/io";
import { IoMdAnalytics } from "react-icons/io";

const CenteredBoxComponent = () => {
  const [animate, setAnimate] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleScroll = () => {
      const element = document.querySelector(".container");
      if (element) {
        const rect = element.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.5) {
          setAnimate(true);
        }
      }
    };

    const handleResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    handleScroll();
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Responsive styles dynamically calculated based on screen width
  const getResponsiveStyles = () => {
    if (windowWidth <= 480) {
      return {
        centeredBoxWidth: "90%",
        imageHeight: "400px",
        verticalLineHeight: "180px",
        padding: "10px",
        flexDirection: "column",
        textAlign: "center",
        imageColumnPadding: "0",
        cornerSize: "40px",
      };
    } else if (windowWidth <= 768) {
      return {
        centeredBoxWidth: "75%",
        imageHeight: "400px",
        verticalLineHeight: "150px",
        padding: "20px",
        flexDirection: "row",
        textAlign: "left",
        imageColumnPadding: "50px",
        cornerSize: "50px",
      };
    }
    return {
      centeredBoxWidth: "40%",
      imageHeight: "500px",
      verticalLineHeight: "200px",
      padding: "30px",
      flexDirection: "row",
      textAlign: "left",
      imageColumnPadding: "150px",
      cornerSize: "60px",
    };
  };

  const styles = getResponsiveStyles();

  return (
    <div>
      <div className={`container ${animate ? "slide-in" : ""}`} style={{ width: "100%", position: "relative" ,marginTop:"100px"}}>
        {/* Background Image */}
        <div style={{ width: "100%", height: styles.imageHeight }}>
          <img
            src="https://img.freepik.com/premium-photo/3d-rendering-modern-living-room-with-shelf_105762-550.jpg"
            alt="Background"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </div>

        {/* Centered Info Box */}
        <div
          style={{
            position: "absolute",
            top: "27%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            background: "white",
            padding: styles.padding,
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            textAlign: "center",
            zIndex: 10,
            width: styles.centeredBoxWidth,
            transition: "all 0.3s ease-in-out",
          }}
        >
          <h2 style={{ fontWeight: "bold", color: "#5c0e14" }}>Structural Engineering</h2>
          <h3>Reliable, Sustainable, and Future-Ready</h3>
          <p>
            Our structural engineering expertise ensures that every project is safe, durable, and cost-effective. We design resilient structures
            that withstand environmental factors while maintaining efficiency and sustainability.
          </p>
        </div>

        {/* Vertical Line (Responsive) */}
        <div
          style={{
            position: "absolute",
            top: "-5%",
            left: "50%",
            transform: "translateX(-50%)",
            width: "2px",
            height: styles.verticalLineHeight,
            background: "#5c0e14",
            zIndex: 20,
          }}
        ></div>

        {/* Two Columns Below the Image */}
        <div style={{ display: "flex", flexWrap: "wrap", flexDirection: styles.flexDirection, marginTop: "50px", padding: styles.padding }}>
          {/* First Column - Added Corner (Top-Right) */}
          <div style={{ flex: "1", padding: styles.padding, textAlign: styles.textAlign, position: "relative" }}>
            {/* Top-Right Corner */}
            <div style={{ position: "absolute", top: "0px", right: "0px", width: styles.cornerSize }}>
              {/* <Corner /> */}
            </div>

            <h2 style={{ fontWeight: "bold", color: "#5c0e14" }}>Design Development</h2>
            <h3 style={{ fontSize: "24px", color: "grey" }}>Refining the Design</h3>
            <p>
              Next, we prepare more detailed drawings to illustrate other aspects of the proposed design. Floor plans show all the rooms in the correct size and shape.
            </p>
          </div>

          {/* Image Column */}
          <div style={{ flex: "1", display: "flex", flexDirection: "column", gap: "20px", paddingLeft: styles.imageColumnPadding }}>
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <IoMdAnalytics
                style={{ width: "50px", height: "50px", borderRadius: "8px" }}
              />
              <span>Structural Analysis & Design</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <IoIosConstruct 
                style={{ width: "50px", height: "50px", borderRadius: "8px" }}
              />
              <span>Earthquake-Resistant & Sustainable Structures</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <SiInstructure 
                style={{ width: "50px", height: "50px", borderRadius: "8px" }}
              />
              <span>Industrial & High-Rise Building Solutions</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CenteredBoxComponent;
